<template>
  <v-card class="pa-4 glass-card">
    <h2 class="section-title">Saved Scenes Gallery</h2>
    <v-row dense>
      <v-col v-for="(scene, i) in savedScenes" :key="i" cols="12" md="6" xl="4">
        <v-card class="pa-4 mb-3 glass-card2">
          <div class="flex-between mb-2">
            <span class="scene-title">{{ scene.name }}</span>
            <div>
              <v-btn icon color="success" @click="$emit('load-scene', i)" title="Load"><v-icon>mdi-arrow-top-right</v-icon></v-btn>
              <v-btn icon color="primary" @click="$emit('edit-scene', i)" title="Edit"><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn icon color="error" @click="$emit('delete-scene', i)" title="Delete"><v-icon>mdi-delete</v-icon></v-btn>
            </div>
          </div>
          <div class="mb-2">{{ scene.prompt }}</div>
          <div>
            <span class="label">Shots:</span> {{ scene.sceneBreakdown.length }},
            <span class="label">Characters:</span> {{ scene.characters.length }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  props: {
    savedScenes: { type: Array, required: true }
  }
}
</script>
<style scoped>
.scene-title {
  font-weight: bold;
  color: #53c6fa;
  font-size: 1.12rem;
  letter-spacing: 1px;
}
.label {
  color: #77d9fa;
  font-weight: 600;
  margin-right: 6px;
}
.glass-card, .glass-card2 {
  background: rgba(32,41,71,0.87) !important;
  border-radius: 17px !important;
  box-shadow: 0 0 22px #0097fb44, 0 1.5px 0 #19e3ff33;
  margin-bottom: 25px;
  border: 1.5px solid #289cf4bb;
}
.section-title {
  font-family: 'Orbitron', monospace;
  color: #67f2ff;
  font-size: 1.5rem;
  margin-bottom: 18px;
  letter-spacing: 1px;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
